/* @flow strict */

import NProgress from 'nprogress';
import available from '/client/src/utils/DOM_available';

import './styles.scss';

type NProgressPropsType = {
  status: boolean
};

const NProgressCustom = (status: NProgressPropsType) => {
  const document = available<{ body?: HTMLBodyElement }>('document', { body: null });

  if (document.body) {
    if (status) {
      NProgress.start();
    } else {
      NProgress.done();
    }
  }
};

export default NProgressCustom;
